import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "common/hoc";
import { MrbPageHeader, MrbPage } from "mrb/components/layout";
import { MrbSelect } from "mrb/components/select";
import { MrbQuerySearchInput } from "mrb/components/input";
import { MrbTable } from "mrb/components/table";
import { TableNoDataOverlay } from "common/components";
import Tabs from "common/components/tabs/Tabs";
import { CertifierBulkActions } from "application/certifier/components";

function CertifierDashboardTemplate({ certifierDashboardViewStore, t }) {
    const { hasMultipleModes, modeSelectStore, tabOptions, selectedTab, setSelectedTab, contentListViewStore } =
        certifierDashboardViewStore;

    const { gridStore, queryUtility, statusFilterStore } = contentListViewStore;

    return (
        <MrbPage>
            <MrbPageHeader>
                <div className="u-display--flex u-display--flex--jc--space-between u-display--flex--ai--center u-width--100">
                    <span>{t("APPLICATION.CERTIFIER.DASHBOARD.TITLE")}</span>
                    {hasMultipleModes && (
                        <div className="u-width--300--px">
                            <MrbSelect
                                t={t}
                                store={modeSelectStore}
                                classNameExtend="c-dropdown--dark c-dropdown--sml"
                            />
                        </div>
                    )}
                </div>
            </MrbPageHeader>

            <div className="u-mar--bottom--med">
                <Tabs
                    id="certifier-content-tabs"
                    value={selectedTab}
                    options={tabOptions.map((tab) => ({ id: tab.id, name: tab.name }))}
                    onChange={setSelectedTab}
                />
            </div>

            <div className="u-mar--bottom--sml c-container--full">
                <div className="u-display--flex u-display--flex--ai--end u-display--flex--wrap" style={{ gap: "20px" }}>
                    <div className="u-flex--grow--1 u-width--800--px">
                        <MrbQuerySearchInput
                            queryUtility={queryUtility}
                            placeholder={t("APPLICATION.CERTIFIER.DASHBOARD.FILTER.SEARCH_PLACEHOLDER")}
                        />
                    </div>
                    <div className="u-flex--shrink--0 u-width--200--px">
                        <MrbSelect t={t} store={statusFilterStore} classNameExtend="c-dropdown--dark c-dropdown--sml" />
                    </div>
                    <div className="u-flex--shrink--0">
                        <CertifierBulkActions contentListViewStore={contentListViewStore} t={t} />
                    </div>
                </div>
            </div>

            <div className="c-content__main">
                <MrbTable
                    t={t}
                    tableStore={gridStore}
                    className="ag-theme-alpine"
                    emptyStateRender={TableNoDataOverlay}
                />
            </div>
        </MrbPage>
    );
}

CertifierDashboardTemplate.propTypes = {
    certifierDashboardViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(CertifierDashboardTemplate);
